import { Observable } from "rxjs";
// import "rxjs/add/operator/timeoutWith";
export type OBS_FN<T> = (...args) => Observable<T | T[]> | T;
export type OBS_HOOK<T> = (result: T) => void;

export interface ExtensionObservableHook<T> {
    hook(extensionResult: T);
}
export class ContributionObservable {

    public static eval<T>(service, obsFunction: OBS_FN<T>, obshook: ExtensionObservableHook<T>, ...args): Observable<T> {
        return Observable.create(observer => {
            let returnData = null;
            try {
                returnData = obsFunction.apply(service, args);
            } catch (error) {
                console.log("There is an error from the contribution function " + error.message);
                console.log(error.stack);
                observer.next(null);
                observer.complete();
            }
            if (typeof returnData === "undefined") {
                observer.next(null);
                observer.complete();
            } else {
                const field = JSON.stringify(args);
                if (returnData !== null && typeof returnData._isScalar !== "undefined") {
                    (<Observable<any>>returnData)
                        .timeoutWith(60000, Observable.throw("Timed out for context"))
                        .subscribe(res => {
                            if (obshook) {
                                obshook.hook(<T>res);
                            }
                            observer.next(res);
                            observer.complete();
                        }, error => {
                            console.log("There is an error from the contribution function " + error);
                            observer.next(null);
                            observer.complete();
                        });
                } else {
                    if (obshook) {
                        obshook.hook(returnData);
                    }
                    observer.next(returnData);
                    observer.complete();
                }
            }
        });

    }
}
